import * as React from 'react'
// components
import ObjectivesList from 'components/PageComponents/Plans/Edit/components/ObjectivesList/index'
// context
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
import { MainLayoutAPIContext } from 'containers/MainLayout/layers/API'
import { ObjectivesListAPIContext } from 'containers/ObjectivesList/layers/API'
import { ObjectivesListTreeBLContext } from 'containers/ObjectivesList/layers/BL/Tree'

const ObjectivesListRenderContainer: React.FC = () => {
  const { isLinkingMode } = React.useContext(LinkingModeContext)
  const { isDrawerExpanded } = React.useContext(MainLayoutAPIContext)
  const { isLoading, updatePlanTree } = React.useContext(ObjectivesListAPIContext)

  const {
    plan,
    entities,
    searchIndex,
    setDeepLevel,
    focuserState,
    setSearchIndex,
    generateNewNode,
    handleSetFocuserState,
    generateCreateRootEntityNode,
    getActiveCreateFormNode,
    getTableCreateFormNode,
    tableCreateForm,
  } = React.useContext(ObjectivesListTreeBLContext)

  return React.useMemo(
    () => (
      <ObjectivesList
        plan={plan}
        entities={entities}
        isLoading={isLoading}
        searchIndex={searchIndex}
        focuserState={focuserState}
        setDeepLevel={setDeepLevel}
        isLinkingMode={isLinkingMode}
        setSearchIndex={setSearchIndex}
        updatePlanTree={updatePlanTree}
        generateNewNode={generateNewNode}
        isDrawerExpanded={isDrawerExpanded}
        handleSetFocuserState={handleSetFocuserState}
        generateCreateRootEntityNode={generateCreateRootEntityNode}
        getActiveCreateFormNode={getActiveCreateFormNode}
        getTableCreateFormNode={getTableCreateFormNode}
        tableCreateForm={tableCreateForm}
      />
    ),
    [entities, focuserState, isLoading, isLinkingMode, searchIndex, plan?.ownedById, tableCreateForm]
  )
}

export default ObjectivesListRenderContainer
